const getCampaignsRoute = (maintenancePageContentWrapper, components, generateRoute) => {
    if (process.env.REACT_APP_IS_IN_MAINTENANCE === "false") {
        return generateRoute(components);
    }
    return generateRoute(maintenancePageContentWrapper);
}

export default getCampaignsRoute;